import React from 'react';
import Segment from '../../helpers/segment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Row, Column, Button, Sizes } from 'react-foundation';
import { Navbar } from '../navbar/navbar';
import { showCreateAccountModal } from '../../state/create-account/actions';
import { SupportEmail } from '../layout/support-email';
import { showLoginModal } from '../../state/auth/actions';

const Landing = React.createClass({
  componentWillMount() {
    Segment.page('App Landing');
    const dispatch = this.props.dispatch;

    const action = this.props.location.query.a;
    if (action === 'login') {
      dispatch(showLoginModal(true));
    } else if (action === 'register') {
      dispatch(showCreateAccountModal(true));
    }
  },

  render() {
    return (
      <div className="page-landing">
        <section className="section-landing">
          <Navbar bgColor="dark" title="Client Portal" {...this.props} />
          <Row>
            <Column
              className="text-center"
              small={12}
              medium={8}
              large={6}
              centerOnMedium
            >
              <h1 className="hero-callout hide-for-small-only">
                {' '}
                Welcome to Nuanced Interpretation!
              </h1>
              <h4 className="description">
                The best platform for finding interpreters.
              </h4>
              <Button
                className="landing-button"
                size={Sizes.LARGE}
                onClick={() => {
                  this.props.dispatch(showCreateAccountModal(true));
                }}
                isHollow
              >
                Signup
              </Button>
              <Button
                className="landing-button"
                size={Sizes.LARGE}
                onClick={() => {
                  this.props.dispatch(showLoginModal(true));
                }}
                isHollow
              >
                Login
              </Button>
            </Column>
          </Row>
        </section>
        <footer className="gray-text">
          <Row className="text-left" isColumn>
            <div>
              <strong>Contact Us</strong>
            </div>
            <div>646-593-1632</div>
            <div>
              <SupportEmail className="gray-text" />
            </div>
            <div>33 Irving Place, New York, NY 10003</div>
            <div>
              Copyright &copy; 2021 Nuanced Interpretation LLC. All rights
              reserved.
            </div>
          </Row>
        </footer>
      </div>
    );
  }
});

export const LandingContainer = withRouter(connect()(Landing));



/** WEBPACK FOOTER **
 ** ./src/components/landing/landing.jsx
 **/